import React, { useState } from "react";
import { Modal, Button, Table, Nav } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import "./style.css";

const TransactionModal = ({ show, handleClose }) => {
  const allTransactions = [
    { date: "07/22/2024", type: "Deposit", amount: "+$5,000.00", status: "Completed" },
    { date: "07/20/2024", type: "Investment", amount: "-$2,000.00", status: "Completed" },
    { date: "07/18/2024", type: "Return", amount: "+$1,500.00", status: "Completed" },
    { date: "07/15/2024", type: "Deposit", amount: "+$3,000.00", status: "Completed" },
    { date: "07/12/2024", type: "Investment", amount: "-$1,000.00", status: "Completed" },
    { date: "07/10/2024", type: "Return", amount: "+$800.00", status: "Completed" },
  ];

  const [activeTab, setActiveTab] = useState("All");

  // ✅ Filter Transactions Based on Active Tab
  const filteredTransactions =
    activeTab === "All"
      ? allTransactions
      : allTransactions.filter((tx) => tx.type === activeTab);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      className="transaction-modal"
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>Transactions</Modal.Title>
        {/* ✅ Proper Icon Button */}
        <Button variant="link" className="btn-close-custom" onClick={handleClose}>
          <X size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <p className="modal-subtitle">
          View and manage your transaction history.
        </p>

        {/* ✅ Tabs with State */}
        <Nav variant="pills" className="mb-3 nav-tabs-custom">
          <Nav.Item>
            <Nav.Link
              active={activeTab === "All"}
              onClick={() => setActiveTab("All")}
            >
              All Transactions
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === "Deposit"}
              onClick={() => setActiveTab("Deposit")}
            >
              Deposits
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === "Investment"}
              onClick={() => setActiveTab("Investment")}
            >
              Investments
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {/* ✅ Scrollable Table */}
        <div className="table-container">
          <Table striped hover responsive className="transaction-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredTransactions.length > 0 ? (
                filteredTransactions.map((tx, index) => (
                  <tr key={index}>
                    <td>{tx.date}</td>
                    <td className="link-text">{tx.type}</td>
                    <td>{tx.amount}</td>
                    <td>
                      <span className="status-badge">{tx.status}</span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No transactions found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TransactionModal;
